import { createContext } from './createContext';
import { ensurePageCa } from '../../utils/ensurePageCa';
import { createApplicationState } from '../applicationState';
import { initMapTelemetry } from '../initMapTelemetry';
import { messageEventManager } from '../messageEventManager';
import { queryStringUpdater } from '../queryStringUpdater';
import { renderApplication } from '../renderApplication';
import { consumeYmapsLoaderEvents } from '../ymapsLoaderEventsConsumer';

export function runApp() {
  const context = createContext();
  const store = createApplicationState(context);

  /** Слой пинов забирает фасад из реестра, поэтому кладём его туда до первого рендера карты */
  initMapTelemetry(context);

  ensurePageCa(context);
  consumeYmapsLoaderEvents(context);

  store.subscribe(() => queryStringUpdater(store.getState()));
  messageEventManager.init(store);

  renderApplication({ store, context });
}
